// extracted by mini-css-extract-plugin
export var aircallIframe = "_dc-3";
export var fabContainer = "_dc-5";
export var fabRinging = "_dc-6";
export var loadingOverlay = "_dc-4";
export var pulse = "_dc-7";
export var widgetContent = "_dc-2";
export var widgetPanel = "_dc-0";
export var widgetPanelExpanded = "_dc-1";